(() => {
  const PREFIX = "ACC_Bitterliebe_Global_22";

  const state = {
    urls: {
      bestSeller: "/collections/produkte-sichtbar/products.json",
      rating:
        "https://api.reviews.io/product/rating-batch?store=bitterliebe.com&sku=",
    },
    bestsellerProducts: [],
    staticRecentSearches: [
      "Bitterliebe Tropfen",
      "Stoffwechsel Kapseln",
      "Stoffwechsel Komplex",
      "Ballaststoff Komplex",
      "Probio Kulturen",
    ],
  };

  const header = document.querySelector("header");

  /** --- Overlay Handling --- */
  const openOverlay = () => {
    header.classList.add(`${PREFIX}-search-visible`, `${PREFIX}-scroll-lock`);
    document.querySelector(`.${PREFIX}-new-search-input`)?.focus();
    document
      .querySelector(`.${PREFIX}-container`)
      .classList.remove("tw-hidden");
  };

  const closeOverlay = () => {
    header.classList.remove(
      `${PREFIX}-search-visible`,
      `${PREFIX}-scroll-lock`
    );
  };

  const bindOverlayEvents = () => {
    // Button im Header (musst du selbst ins Markup setzen)
    document.querySelectorAll(`[winning-search-button]`).forEach((btn) => {
      btn.addEventListener("click", openOverlay);
    });

    // X-Button im Input
    document
      .querySelector(`.${PREFIX}-search-bar-wrapper button[type="button"]`)
      ?.addEventListener("click", closeOverlay);

    // Klick außerhalb
    document.addEventListener("click", (e) => {
      const container = document.querySelector(`.${PREFIX}-container`);
      if (!container) return;
      if (!document.body.classList.contains(`${PREFIX}-search-visible`)) return;

      if (
        !e.target.closest(`.${PREFIX}-container`) &&
        !e.target.closest(`.${PREFIX}-search_button_wrapper`)
      ) {
        closeOverlay();
      }
    });

    // ESC-Taste
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeOverlay();
    });
  };

  /** --- Recent Searches --- */
  const renderRecentSearches = () => {
    try {
      let history =
        JSON.parse(sessionStorage.getItem(`${PREFIX}-recent-searches`)) || [];
      let searches = [...history, ...state.staticRecentSearches];
      searches = [...new Set(searches)].slice(0, 5);

      const wrapper = document.querySelector(
        `.${PREFIX}-search-bar-result-wrapper`
      );
      if (!wrapper) return;

      wrapper.innerHTML = searches
        .map(
          (term, i) => `
        <a href="/pages/search-results-page?q=${encodeURIComponent(term)}"
           class="${PREFIX}-search-bar-result-copy-content ${PREFIX}-search-bar-result-copy-content-${i}">
          <div class="${PREFIX}-search-bar-result-copy">${term}</div>
        </a>`
        )
        .join("");
    } catch (err) {
      console.error("Recent searches render failed:", err);
    }
  };

  /** --- Ratings --- */
  const updateRatings = async () => {
    if (!state.bestsellerProducts.length) return;

    for (let [index, product] of state.bestsellerProducts.entries()) {
      try {
        const skus = product.variants.map((v) => v.sku).join(";");
        const ids = product.variants.map((v) => v.id).join(";");
        const query = `${product.handle};${skus};${ids}`;
        const res = await fetch(state.urls.rating + query).then((r) =>
          r.json()
        );

        if (!Array.isArray(res) || !res.length) continue;

        const totalRatings = res.reduce(
          (sum, r) => sum + (r.num_ratings || 0),
          0
        );
        const avg =
          res.reduce(
            (sum, r) => sum + r.average_rating * (r.num_ratings || 0),
            0
          ) / totalRatings;

        const full = Math.floor(avg);
        const partial = Math.round((avg % 1) * 4) * 25;
        const empty = 5 - full - (partial > 0 ? 1 : 0);

        const stars = `${'<i aria-hidden="true" class="ruk-icon-percentage-star--100"></i>'.repeat(
          full
        )}
           ${
             partial
               ? `<i aria-hidden="true" class="ruk-icon-percentage-star--${partial}"></i>`
               : ""
           }
           ${'<i aria-hidden="true" class="ruk-icon-percentage-star--0"></i>'.repeat(
             empty
           )}`;

        const el = document.querySelector(
          `.${PREFIX}-product-card-${index} .ruk_rating_snippet`
        );
        if (el) {
          el.innerHTML = `
            ${stars}
            <span class="ruk-rating-snippet-count" style="color: rgb(95,101,99)">(${totalRatings})</span>
          `;
        }
      } catch (err) {
        console.warn("Rating fetch failed for", product.handle, err);
      }
    }
  };

  /** --- Search Submit --- */
  const bindSearchInput = () => {
    const input = document.querySelector(`.${PREFIX}-new-search-input`);
    if (!input) return;

    input.addEventListener("keydown", (e) => {
      if (e.key !== "Enter") return;
      e.preventDefault();
      if (!input.value.trim()) return;

      let history =
        JSON.parse(sessionStorage.getItem(`${PREFIX}-recent-searches`)) || [];
      history = [input.value.trim(), ...history];
      sessionStorage.setItem(
        `${PREFIX}-recent-searches`,
        JSON.stringify([...new Set(history)])
      );

      window.location.href = `/pages/search-results-page?q=${encodeURIComponent(
        input.value.trim()
      )}`;
    });
  };

  /** --- Init --- */
  const init = async () => {
    renderRecentSearches();
    bindSearchInput();
    bindOverlayEvents();

    /* try {
      const data = await fetch(state.urls.bestSeller).then((r) => r.json());
      if (data?.products) {
        state.bestsellerProducts = data.products.slice(0, 4);
        await updateRatings();
      }
    } catch (err) {
      console.warn("Bestsellers fetch failed:", err);
    } */
  };

  document.addEventListener("DOMContentLoaded", init);
})();
